export interface ListingOverlayFormat {
	key: string;
	width: number;
	height: number;
}

export interface PageSize {
	width: number;
	height: number;
}

export const LISTING_OVERLAY_FORMATS: ListingOverlayFormat[] = [
	{ key: 'Portrait', width: 1080, height: 1350 },
	{ key: 'Story', width: 1080, height: 1920 },
	{ key: 'Landscape', width: 1200, height: 630 },
	{ key: 'Square', width: 1080, height: 1080 },
];

export const getEffectivePageSize = (json: any, page: any): PageSize => {
	const jsonW = Number(json?.width);
	const jsonH = Number(json?.height);

	const pageWRaw = page?.width;
	const pageHRaw = page?.height;
	const pageW = pageWRaw === 'auto' || pageWRaw == null ? jsonW : Number(pageWRaw);
	const pageH = pageHRaw === 'auto' || pageHRaw == null ? jsonH : Number(pageHRaw);

	return { width: pageW, height: pageH };
};

export const matchListingOverlayFormat = (
	dimensions: Partial<PageSize> = {},
): ListingOverlayFormat | null => {
	const width = Number(dimensions?.width);
	const height = Number(dimensions?.height);

	if (!Number.isFinite(width) || !Number.isFinite(height)) return null;
	return (
		LISTING_OVERLAY_FORMATS.find((format) => {
			return width === format.width && height === format.height;
		}) || null
	);
};

export const LISTING_OVERLAY_FORMAT_BY_PAGE_ID: Record<string, string> = {
	page_1: 'portrait',
	page_2: 'story',
	page_3: 'landscape',
	page_4: 'square',
};

interface OverlayRaster {
	url?: string;
	formatKey?: string;
	pageId?: string;
}

export const buildListingOverlayPreviewsFromRasters = (
	rasters: OverlayRaster[],
): Record<string, string> => {
	const previews: Record<string, string> = {};

	(Array.isArray(rasters) ? rasters : []).forEach((raster) => {
		if (!raster?.url) return;

		const formatKey = String(raster.formatKey || '').toLowerCase();

		if (formatKey === 'fullsize') {

			const format = LISTING_OVERLAY_FORMAT_BY_PAGE_ID[raster.pageId];
			if (format) {
				previews[format] = raster.url;
			}
			return;
		}

		if (formatKey === 'thumbnail') {
			// Keep one lightweight thumbnail (portrait/page_1 preferred) as a fallback for when a
			// fullSize format is missing; fullSize still drives the actual overlay previews above.
			if (raster.pageId === 'page_1' || !previews.thumbnail) {
				previews.thumbnail = raster.url;
			}
		}
	});

	return previews;
};
